import AdminLayout from "./AdminLayout";
import AdminBroadcast from "./AdminBroadcast";

export default function AdminBroadcastPage() {
  return (
    <AdminLayout>
      <AdminBroadcast />
    </AdminLayout>
  );
}
